<div id="app-header-container">
  <div class="app-header-container">
    <div class="home-icon cursor-pointer" *ngIf="!headerData.homeBtnCb && !headerData.disableHeader">
      <img class="switch-panel-icon" src="/assets/images/panel_switch_menu.svg" alt="Switch Panel Menu Icon"
        (click)="openSwitchPanelDialog()">
      <img routerLink="/overview" class="product-exeperience" src="/assets/images/product-experience-netcore-logo.svg"
        alt="Netcore Customer Engagement">
    </div>

    <mat-toolbar color="primary" class="header-cont" [ngStyle]="{'padding-left':  getPaddingLeftValue()}">
      <mat-toolbar-row style="height:86px;" *ngIf="!headerData.disableHeader">
        <span>
          <span *ngIf="headerData.breadCrumb">
            <span *ngFor="let breadCrumb of headerData.breadCrumb; let i=index;">
              <span class="app-colon" *ngIf="i >= 1"> &nbsp; : &nbsp; </span>
              <mat-icon class="os-icon" *ngIf="breadCrumb.icon">{{breadCrumb.icon}}</mat-icon>
            </span>
          </span>
        </span>
      </mat-toolbar-row>

      <mat-toolbar-row class="auto-height" *ngIf="headerData.disableHeader">
        <div class="overflow-protect-div" style="height:86px; margin-top: 1.5em;">
          <ng-container *ngIf="!headerData.closeIframeOnBackBtnCb">
            <i class="material-icons icon-button-light" [routerLink]="headerData.previousPagePath"
              *ngIf="!headerData.backBtnCb" style="position: relative;top: 3px;">
              arrow_back
            </i>
            <i class="material-icons icon-button-light"
              (click)="headerData.backBtnCb({'href' : headerData.previousPagePath})" *ngIf="headerData.backBtnCb"
              style="position: relative;top: 3px;">
              arrow_back
            </i>
          </ng-container>
          <ng-container *ngIf="headerData.closeIframeOnBackBtnCb">
            <i class="material-icons icon-button-light" (click)="headerData.closeIframeOnBackBtnCb()"
              style="position: relative;top: 3px;">
              arrow_back
            </i>
          </ng-container>
          <div class="journey-details-container">
            <div class="px-heading-3 text-capitalize journey-name">{{headerData.title || ''}}&nbsp;</div>
            <div class="journey-info px-subtitle">
              <div *ngIf="headerData['status']" class="status-container {{headerData['status']}}">
                {{ headerData['status'] }}
              </div>
              <ng-container *ngIf="headerData.hasOwnProperty('journeyDetails')">
                <div class="ml-4 journey-details text-truncate">
                  <ng-container *ngTemplateOutlet="journeyDetails; context:{}"></ng-container>
                </div>
                <div class="journey-details-tooltip">
                  <ng-container *ngTemplateOutlet="journeyDetails; context:{}"></ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>


    <div class="right-section" *ngIf="!this.headerData.hideRightSideDetail">
      <div class="custom-menu-container" (click)="$event.stopPropagation();">
        <div id="menu-label-container" class="label-container d-flex justify-content-between align-items-center"
          (click)="toggleMenu($event)" [ngClass]="{'active': shouldShowMenu}">
          <span id="label" [ngStyle]="{'color': label ? '#17173A' : '#6f6f8d'}">
            <app-platform-icon class="ml-1 mr-2" [platform]="selectedApp.app?.os"></app-platform-icon>
            {{selectedApp.app?.name || 'Select APP'}}
          </span>
          <i class="material-icons">
            expand_more
          </i>
        </div>
        <ng-container *ngIf="shouldShowMenu">
          <app-custom-dropdown [itemsMap]="appListMap" [tabs]="tabs" [selectedTabIndex]="selectedTabIndex"
            [clonedItemsMap]="clonedAppListMap" [singleSelect]="true" [tabIndexLabelMap]="tabIndexLabelMap"
            [listSubHeader]="listSubHeader" (shouldShowMenuClose)="shouldClose($event)">
          </app-custom-dropdown>
        </ng-container>
      </div>

      <button id="hslBeamerBtn" class="setting-dropdown account-dropdown" mat-button md-no-ink>
        <img class="acc-icon" src="/assets/images/whatshot_24px.svg" alt="what's hot">
        <span class="text-color">What's New</span>
      </button>
      <div class="profile-menu-dropdown">
        <div mat-button class="profile-dropdown" [matMenuTriggerFor]="profile" md-no-ink>
          <div class="profile-name">
            <p class="name text-truncate">{{userData.name}}
              <span class="down-arrow"></span>
            </p>
          </div>
        </div>
        <mat-menu #profile="matMenu">
          <div class="profile-menu">
            <div class="menu-header">
              <div class="anonymous-image">
                <img src="/assets/images/Avatars Anonymous.svg">
              </div>
              <div class="pr-0">
                <div class="name text-truncate">{{userData.name}}</div>
                <div class="email text-truncate">{{userData.email}}</div>
              </div>
            </div>
            <div *ngFor="let menu of settingMenuItem">
              <span class="menu text" appDisableFeature [pathString]="'account_settings.' + menu.featureName + '.cta'"
                *ngIf="!menu.hide" (click)="changeRoute('/settings', {'section' : menu.section})">
                <img class="menu-image" [src]="menu.img">
                {{menu.text}}
              </span>
            </div>
            <div class="border-bottom"></div>
            <div>
              <span class="menu text profile-setting" (click)="changeRoute('/user-settings')" appDisableFeature
                [pathString]="'user_settings.profile_settings'" *ngIf="!profileSettings.profile.hide">
                <img class="menu-image" src="/assets/images/profile.svg">
                Profile Settings
              </span>
            </div>
            <div>
              <a href="mailto:helpdesk@netcorecloud.com?subject=Requesting%20support%20for%20PX%20-%20%5Bissue%20summary%5D"
                class="menu text">
                <img class="menu-image" src="/assets/images/Ticket.svg">
                Raise support ticket
              </a>
            </div>
            <div class="border-bottom"></div>
            <div>
              <span class="menu logout-text" (click)="logout()">
                <img class="logout-image" src="/assets/images/logout.svg">
                Signout
              </span>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>

  <div id="hansel-loader">
    <app-px-loader></app-px-loader>
  </div>
  <mat-tab-group class="sub-header" [ngClass]="{'disableTab' : headerData.disbaleSubHeader}"
    [selectedIndex]="subHeaderData.selectedTab" [style.padding-left]="ifBackBtnPresent() ? '7.3em' : '7.3em'"
    (selectedTabChange)="onClickLabel($event)">
    <div *ngFor="let label of subHeaderData.labels;">
      <mat-tab *ngIf="!label.hidden" [disabled]="label.disabled">
        <ng-template mat-tab-label>
          <mat-icon *ngIf="label.icon">{{label.icon}}</mat-icon>
          <ng-container *ngIf="label.icon">&nbsp;</ng-container>
          {{label.name}}
        </ng-template>
      </mat-tab>
    </div>
  </mat-tab-group>
</div>
<ng-template #journeyDetails>
  ID: {{headerData.journeyDetails.jid_hash}}
  <span class="pipe"></span>
  <ng-container *ngIf="headerData.journeyDetails.smt_jname">
    Part of CE Journey ID: {{headerData.journeyDetails.smt_jid}}
    '{{headerData.journeyDetails.smt_jname}}'
    <span class="pipe"></span>
  </ng-container>
  Start - End date:
  {{getFormattedDate(headerData.journeyDetails.start_date)}}
  <ng-container *ngIf="!isNeverEndingJourneyDate(headerData.journeyDetails.end_date)">
    - {{getFormattedDate(headerData.journeyDetails.end_date)}}
  </ng-container>
  <ng-container *ngIf="isNeverEndingJourneyDate(headerData.journeyDetails.end_date)">
    - Never ending journey
  </ng-container>
</ng-template>
